import { Chip, type SxProps } from '@mui/material';
import { Autocomplete } from '@ovComponents/2-component/autocomplete/autocomplete';
import { useCountryList } from '@ovComponents/resources';
import { Box } from 'hephaestus/web';
import { isArray } from 'lodash-es';
import { useTranslation } from 'react-i18next';

export const CitizenshipField = ({
  onChange,
  label,
  readonly = false,
  citizenships,
  singleSelect = false,
  sx,
  error,
  infoTooltip,
  testId,
  lockMessage,
  locked,
}: {
  onChange: (citizenships: string[]) => void;
  label?: string;
  rows?: number;
  readonly?: boolean;
  singleSelect?: boolean;
  citizenships: string[];
  sx?: SxProps;
  error?: boolean;
  infoTooltip?: string;
  lockMessage?: string;
  locked?: boolean;
  testId?: string;
}) => {
  const { t } = useTranslation('components');
  const countryList = useCountryList();

  return (
    <Box sx={sx as any}>
      <Autocomplete
        multiple={!singleSelect}
        data-testid='citizenshipField'
        testId={testId}
        freeSolo
        value={citizenships?.map(
          (citizen) =>
            countryList.find((country) => country.code === citizen)?.name ?? '',
        )}
        options={countryList.map((country) => ({ label: country.name }))}
        fullWidth
        disabled={readonly}
        label={label ?? t('components:citizenshipInput.label')}
        infoTooltip={infoTooltip}
        error={error}
        lockMessage={lockMessage}
        locked={locked}
        isOptionEqualToValue={(option: any, value: any) =>
          option.label === value
        }
        onChange={(_e: any, value: any) => {
          if (isArray(value)) {
            const newCiti = value.map((x: any) => {
              if (x.label) {
                return (
                  countryList.find((country) => country.name === x.label)
                    ?.code ?? ''
                );
              }
              return (
                countryList.find((country) => country.name === x)?.code ?? ''
              );
            });
            onChange(newCiti);
          } else {
            onChange([
              countryList.find((country) => country.name === value?.label)
                ?.code || '',
            ]);
          }
        }}
        renderTags={(tagValue: any, getTagProps: any) =>
          tagValue.map((option: any, index: number) => (
            <Chip
              label={option}
              sx={{ marginTop: '-2px !important' }}
              {...getTagProps({ index })}
              size='small'
              onDelete={undefined}
            />
          ))
        }
      />
    </Box>
  );
};

export default CitizenshipField;
